<template>
  <!--  <div id="app" v-show="$store.state.isAuth">-->
  <div id="app">
    <SjCard
      class="navBox"
      v-if="
        $route.name !== 'reportDetail' &&
          $route.name !== 'no-auth' &&
          $route.name !== 'auth'
      "
    >
      <div class="navIcon">
        <SjImage
          :imageStyle="{ width: '94px', height: '48px' }"
          :src="themeType === 'dark' ? darkLogo : logo"
          class="logo"
        ></SjImage>
      </div>
      <div class="navContainer">
        <NavBar :data="navData"></NavBar>
      </div>
    </SjCard>
    <div class="contentBox">
      <router-view class="content" />
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="1250px"
      @close="onDialogClose"
    >
      <div style="position: relative">
        <!-- <el-button
          style="position: absolute;top: -50px"
          type="primary"
          @click="onLinkClick"
          >盈利预测</el-button
        > -->
        <iframe
          width="1200px"
          height="600px"
          v-if="dialogVisible"
          :src="url"
          frameborder="no"
          border="0"
          marginwidth="0"
          marginheight="0"
          scrolling="no"
          allowtransparency="yes"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import logo from "@/assets/images/logo.png";
import darkLogo from "@/assets/images/darklogo.png";
import EventBus from "@/eventBus";
import { getUrlParams } from "@/utils";

export default {
  components: {
    NavBar
  },
  watch: {
    "$route.query"(query) {
      if (query.domain) {
        this.$store.state.domain = query.domain;
      }

      if (query.userno) {
        if (window.sensors && window.sensors.login) {
          console.log("用户关联：", query.userno);
          window.sensors.login(query.userno);
        }
      }

      if (query.token) {
        this.$store.state.token = query.token;
      }

      if (query.username) {
        this.$store.state.username = query.username;
      }

      if (query.themeType) {
        // this.$store.state.theme = query.themeType;
      }

      if (query.nickname) {
        this.$store.state.nickname = query.nickname;
      }
    }
  },
  data() {
    return {
      logo,
      darkLogo,
      dialogVisible: false,
      linkUrl: null,
      url: null,
      themeType: getUrlParams("themeType")
    };
  },
  beforeCreate() {
    let _this = this;
    let themeType = getUrlParams("themeType");
    themeType && (themeType = themeType.toLowerCase());
    document.getElementsByTagName("body")[0].className = `${themeType}-theme`;
    /**
     * 换肤
     *
     * @param {any} code 皮肤Code
     * @param {any} flag 是否执行加载默认皮肤
     */
    function nativeActions(type, theme) {
      theme && (theme = theme.toLowerCase());
      if (type == 'themeType') {
        if (theme == 'dark' || theme == 'black') {
          skin('dark', true)
        }
        if (theme == 'white' || theme == 'light') {
          skin('white', true)
        }
      }
    }
    function skin(code, flag) {
      var ybHtml = document.getElementsByTagName("html")[0];
      var codeFuncMapping = {
        "dark": function(){
          ybHtml.setAttribute("style", "background-color: #001125;");
          document.getElementsByTagName("body")[0].className = code + '-theme';
        },
        "white": function(){
          ybHtml.removeAttribute("style");
          document.getElementsByTagName("body")[0].className = code + '-theme';
        }
      }
      var func = codeFuncMapping[code];
      if(func){
        func();
        _this.themeType = code;
        _this.$store.state.theme = code;
      }
    }
    window.nativeActions = nativeActions;
  },
  created() {
    EventBus.$on("showStockDialog", this.showStockDialog);

    setInterval(() => {
      const viewReportStr = window.localStorage.getItem(
        "view_research_report_page"
      );
      if (viewReportStr && viewReportStr.length) {
        window.localStorage.removeItem("view_research_report_page");
        window.sendEvent(
          "view_research_report_page",
          JSON.parse(viewReportStr)
        );
      }
    }, 3000);
  },
  beforeDestroy() {
    EventBus.$off("showStockDialog", this.showStockDialog);
  },
  methods: {
    onDialogClose() {
      this.url = null;
      this.linkUrl = null;
    },
    async showStockDialog(data) {
      this.url =
        "https://xinhua500.cnfic.com.cn/quotegraph/index.html#/quoteChart?code=" +
        (data.V_SECURITYCODE || data.SECURITYCODE);
      this.url +=
        (data.V_SECURITYCODE || data.SECURITYCODE).substring(0, 1) + "" === "6"
          ? ".SS"
          : ".SZ";

      this.dialogVisible = true;

      // TODO 调整至原系统盈利预测
      const params = {
        token: this.$store.state.token,
        domain: this.$store.state.domain,
        keyWord: data.SECURITYCODE || data.V_SECURITYCODE,
        start: 0,
        needCount: 1,
        tagTitle: "上市公司",
        path: "ylyc",
        username: this.$store.state.username
      };
      const result = await this.$apis.Base.getLinkUrl(params);
      this.linkUrl = result.url;
    },
    onLinkClick() {
      if (this.linkUrl) {
        window.open(this.linkUrl);
      }
    }
  },
  destroyed() {
    EventBus.$off("showStockDialog", this.showStockDialog);
  },
  computed: {
    navData() {
      return this.$store.state.navData;
    }
  }
};
</script>

<style lang="less">
#app {
  overflow: hidden;
  height: 100%;
  min-width: 1200px;
  min-height: 600px;
  display: flex;
  align-items: stretch;

  .navBox {
    width: 150px;
    border-radius: 0;
    display: flex;
    flex-direction: column;

    .navIcon {
      margin-top: 11px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .navContainer {
      flex: 1;
      min-height: 0;
    }
  }

  .contentBox {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: stretch;

    .content {
      flex: 1;
      min-width: 0;
      min-height: 0;
    }
  }
}

@import "assets/styles/theme.less";
</style>
